module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/component-8fe9ee98158f6aacd1eaecd131430559.svg";